import axios from 'axios';
import jwt from 'jsonwebtoken';

import Config from '../config';
import HttpClient from './HttpClient';

class TokenService {
  private publicKey: { [key: string]: string } = {};

  public async verifyAccessTokenAsync(token: string): Promise<boolean> {
    if (!token) {
      return false;
    }
    var decoded = jwt.decode(token, { complete: true });
    const kid = decoded['header'].kid;
    const publicKey = await this.getTokenSigningPublicKey(kid);
    const verified = jwt.verify(token, publicKey, {
      algorithms: ['RS256']
    });

    return !!verified;
  }

  private async getOpenidConfiguration() {
    try {
      const { data } = await HttpClient.get(
        `${Config.IDP}/.well-known/openid-configuration`
      );

      return data;
    } catch (error) {
      throw error;
    }
  }

  private async getTokenSigningPublicKey(kid: string): Promise<string> {
    if (this.publicKey[kid]) {
      return this.publicKey[kid];
    }
    try {
      const { data } = await axios.get<{ signingkey: string }>(
        `/auth/signingkey/${kid}`
      );
      this.publicKey[kid] = data.signingkey;

      return this.publicKey[kid];
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}

export default new TokenService();
